// Extract a human-readable message from a failed Location API call.
//
// Mirrors `features/User/utils/getApiErrorMessage.ts` (duplicated locally —
// pantry features don't import from each other) with two additions:
//   - the bs-core response interceptor usually rethrows the backend `message`
//     as a bare string, or the raw `response.data` object when it has no
//     `message` (libs/bs-core/src/httpClient/interceptors.ts), so both shapes
//     are handled alongside a raw Axios error;
//   - `display_message` is read as well as `message`.
// Falls back to the caller-supplied copy so the UI never shows a blank error.

const fromPayload = (payload: unknown): string | undefined => {
  if (typeof payload === 'string') return payload.trim() || undefined
  if (payload && typeof payload === 'object') {
    const record = payload as { message?: unknown; display_message?: unknown }
    for (const value of [record.message, record.display_message]) {
      if (typeof value === 'string' && value.trim()) return value
    }
  }
  return undefined
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (typeof err === 'string') return err.trim() || fallback
  const response = (err as { response?: { data?: unknown } })?.response
  return fromPayload(response?.data) ?? fromPayload(err) ?? fallback
}
